module.exports = __webpack_public_path__ + "89ecee94c227837b9bceb5ab1cd779af.png";


//////////////////
// WEBPACK FOOTER
// ./assets/Images/SwiftImageIcons/Colored/1x/Coinincrease.png
// module id = 1428
// module chunks = 0